exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#reviews[data-v-75090b6f]{font-size:.8rem}.review[data-v-75090b6f]{width:100%}.review-buttons-panel button[data-v-75090b6f]{border-radius:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75090b6f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/Reviews.vue
// module id = 165
// module chunks = 0